import { useAuth } from '@/features/auth/stores/auth.store'
import Page from '@/components/custom/Page'
import { useWorkspace } from '@/features/workspace/stores/workspace.store'
import { Button } from '@/shared/components/ui/button'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { WorkspaceLayout } from '@/features/workspace'
import { SpEditorProvider } from '@/features/screenplay/components/editor/SpEditorProvider'
import { useCreateScreenplayMutation, useScreenplayQuery } from '../queries/screenplay.queries'
import { toastService } from '@/shared/services/toast.service'
import Loading from '@/components/custom/loading'
import { DEFAULT_CONTENT } from '../components/editor/SpEditor'

const EditorWrapper = ({ children }: { children: React.ReactNode }) => (
    <SpEditorProvider>{children}</SpEditorProvider>
)

const AddScreenPlay = () => {
    return (
        <WorkspaceLayout optionBar={<></>} ProviderWrapper={EditorWrapper}>
            <AddScreenPlayContent />
        </WorkspaceLayout>
    )
}

const AddScreenPlayContent = () => {
    const { user } = useAuth()
    const { project } = useWorkspace()
    const router = useNavigate()
    const fileName = 'master'

    const { data: existingScreenplay, isLoading } = useScreenplayQuery(project?.id, fileName)

    const createScreenplayMutation = useCreateScreenplayMutation({
        onSuccess: () => {
            toastService.success("Screenplay created successfully")
            router(`/workspace/${project!.id}/screenplay/`)
        },
        onError: (error) => {
            console.error('Failed to create screenplay', error)
            toastService.error("Failed to create screenplay")
        }
    })

    const addScreenplay = async () => {
        if (!project || !user) return

        const timestamp = new Date()
        const screenplayId = crypto.randomUUID()
        const screenplayData = {
            id: screenplayId,
            content: DEFAULT_CONTENT,
            created_at: timestamp,
            updated_at: timestamp,
            title: fileName,
            userId: user.uid,
            projectId: project.id,
        }
        createScreenplayMutation.mutate(screenplayData)
    }

    useEffect(() => {
        if (existingScreenplay) {
            router(`/workspace/${project!.id}/screenplay/`)
        }
    }, [existingScreenplay, project, router])

    if (isLoading) return <div><Loading /></div>

    return (
        <Page>
            <div className="flex flex-col items-center justify-center h-full">
                <h1 className="text-2xl font-bold mb-4">No Screenplay Yet — Let’s Create One!</h1>
                <p className="text-gray-600 mb-6">
                    It looks like there’s no screenplay for this project yet. Add your script to get
                    started and shape your story.
                </p>
                <Button onClick={addScreenplay} className="cursor-pointer" disabled={createScreenplayMutation.isPending}>
                    {createScreenplayMutation.isPending ? "Creating..." : "Start Screenplay"}
                </Button>
            </div>
        </Page>
    )
}

export default AddScreenPlay
